import g, { css as a } from "styled-components";
import { COLOR_VARIANT as n } from "../../../constants/colorVariant.es.js";
const c = g.div.withConfig({
  displayName: "BadgeBullet",
  componentId: "sc-1iffd1p-0"
})([""]), b = {
  getSizeStyles: (o) => ({
    sm: {
      height: "var(--size-24)",
      padding: "0px var(--size-padding-8)",
      gap: "var(--size-gap-4)"
    },
    md: {
      height: "var(--size-32)",
      padding: "0px var(--size-padding-12)",
      gap: "var(--size-gap-6)"
    },
    lg: {
      height: "var(--size-40)",
      padding: "0px var(--size-padding-16)",
      gap: "var(--size-gap-8)"
    }
  })[o]
}, e = {
  successWeak: {
    color: "var(--color-fg-weaker)",
    border: "var(--color-success-default)",
    colorInvert: "var(--color-success-strongest)"
  },
  successDefault: {
    color: "var(--color-fg-default)",
    border: "var(--color-success-strong)",
    colorInvert: "var(--color-fg-inverse-default)"
  },
  successStrong: {
    color: "var(--color-fg-strong)",
    border: "var(--color-success-strongest)",
    colorInvert: "var(--color-fg-inverse-default)"
  },
  infoWeak: {
    color: "var(--color-fg-weaker)",
    border: "var(--color-info-default)",
    colorInvert: "var(--color-info-strongest)"
  },
  infoDefault: {
    color: "var(--color-fg-default)",
    border: "var(--color-info-strong)",
    colorInvert: "var(--color-fg-inverse-default)"
  },
  infoStrong: {
    color: "var(--color-fg-strong)",
    border: "var(--color-info-strongest)",
    colorInvert: "var(--color-fg-inverse-default)"
  },
  warningWeak: {
    color: "var(--color-fg-weakest)",
    border: "var(--color-warning-default)",
    colorInvert: "var(--color-warning-strongest)"
  },
  warningDefault: {
    color: "var(--color-fg-default)",
    border: "var(--color-warning-strong)",
    colorInvert: "var(--color-fg-default)"
  },
  warningStrong: {
    color: "var(--color-fg-strong)",
    border: "var(--color-warning-strongest)",
    colorInvert: "var(--color-fg-default)"
  },
  errorWeak: {
    color: "var(--color-fg-weakest)",
    border: "var(--color-error-default)",
    colorInvert: "var(--color-error-default)"
  },
  errorDefault: {
    color: "var(--color-fg-default)",
    border: "var(--color-error-strong)",
    colorInvert: "var(--color-bg-default)"
  },
  errorStrong: {
    color: "var(--color-fg-strong)",
    border: "var(--color-error-strongest)",
    colorInvert: "var(--color-bg-default)"
  },
  bgWeak: {
    color: "var(--color-bg-weaker)",
    border: "var(--color-bg-strong)",
    colorInvert: "var(--color-bg-strongest)"
  },
  bgDefault: {
    color: "var(--color-bg-default)",
    border: "var(--color-bg-strong)",
    colorInvert: "var(--color-fg-default)"
  },
  bgStrong: {
    color: "var(--color-bg-strong)",
    border: "var(--color-bg-strongest)",
    colorInvert: "var(--color-bg-strongest)"
  }
}, h = g.div.withConfig({
  displayName: "Badge",
  componentId: "sc-1iffd1p-1"
})(["", ""], ({
  color: o,
  disabled: l,
  variant: t,
  error: d,
  success: s,
  rounded: v,
  size: i,
  closable: f
}) => {
  const r = b.getSizeStyles(i);
  return a(["", " align-items:center;background-color:", ";border:1px solid ", ";border-radius:var(--size-border-radius-md);color:", ";cursor:pointer;display:flex;justify-content:space-between;transition:all 0.2s ease-in-out;width:fit-content;", "{background-color:", ";border-radius:calc(", " / 2);height:calc(", " / 3);width:calc(", " / 3);}&:hover{background-color:transparent;color:", ";", "{background-color:", ";}}", " ", " ", " ", " ", " ", ";", ""], r, e[o].color, e[o].border, e[o].colorInvert, c, e[o].border, r == null ? void 0 : r.height, r == null ? void 0 : r.height, r == null ? void 0 : r.height, e[o].colorInvert, c, e[o].border, t === n.outlined && a(["background-color:var(--color-bg-default);color:", ";", "{background-color:", ";}&:hover{background-color:", ";border:1px solid ", ";color:", ";", "{background-color:", ";}}"], e[o].border, c, e[o].border, e[o].color, e[o].border, e[o].colorInvert, c, e[o].border), t === n.text && a(["background-color:transparent;border:none;color:", ";&:hover{text-decoration:underline;}"], e[o].border), f && a(["padding-right:calc(", " * 1.155);"], r == null ? void 0 : r.gap), d && a(["border:2px solid var(--color-error-default);color:var(--color-error-weaker);"]), s && a(["border:2px solid var(--color-success-default);"]), l && a(["cursor:not-allowed;opacity:0.4;pointer-events:all !important;"]), v && a(["border-radius:calc(", " / 2);"], r == null ? void 0 : r.height));
});
export {
  h as Badge,
  c as BadgeBullet
};
//# sourceMappingURL=style.es.js.map
